<template>
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            {{ currentLang === 'ar' ? 'منصة أكاديميا Academia' : 'Academia Platform' }}
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">
                {{ currentLang === 'ar' ? 'الصفحة الرئيسية' : 'Home' }}
              </a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">
              {{ currentLang === 'ar' ? 'سياسة حذف الحساب' : 'Account Deletion Policy' }}
            </li>
          </ul>
        </div>
        <!--end::Page title-->

        <!--begin::Language Toggle-->
        <div class="d-flex align-items-center">
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-sm"
              :class="currentLang === 'en' ? 'btn-success' : 'btn-light-success'"
              @click="setLanguage('en')"
            >
              EN
            </button>
            <button
              type="button"
              class="btn btn-sm"
              :class="currentLang === 'ar' ? 'btn-success' : 'btn-light-success'"
              @click="setLanguage('ar')"
            >
              AR
            </button>
          </div>
        </div>
        <!--end::Language Toggle-->
      </div>
    </div>
    <!--end::Toolbar-->

    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10" id="section-content">
          <div class="col-12">
            <div class="card shadow-lg border-0 rounded-4 h-100 bg-light">
              <div class="card-body p-5">
                <!-- Header with Logo and Icon -->
                <div class="text-center mb-5">
                  <div class="mb-0 mb-lg-2 custom-logo" style="text-align: center">
                    <img
                      alt="Logo"
                      src="assets/img/logo-dark.png"
                      class="h-60px h-lg-75px"
                    />
                  </div>
                  <div
                    class="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 rounded-circle p-4 shadow-sm"
                  >
                    <i
                      class="fas fa-user-slash fa-1x text-success"
                      style="font-size: 18px"
                    ></i>
                  </div>
                  <h2 style="font-weight: 700" class="fw-bold mt-3 text-dark">
                    {{ currentLang === 'ar' ? 'سياسة حذف الحساب والخصوصية' : 'Account Deletion & Privacy Policy' }}
                  </h2>
                  <p class="text-muted">
                    {{ currentLang === 'ar' ? 'تاريخ النفاذ' : 'Effective Date' }}: 21/04/2025
                  </p>
                </div>

                <!-- Content Section -->
                <div class="policy-content" :dir="currentLang === 'ar' ? 'rtl' : 'ltr'">
                  
                  <!-- Warning Box Before Deletion Policy -->
                  <div class="alert alert-warning d-flex align-items-center mb-4" role="alert">
                    <i class="fas fa-exclamation-triangle me-3 fs-3" :class="currentLang === 'ar' ? 'ms-3 me-0' : ''"></i>
                    <div>
                      <strong>{{ content[currentLang].warning.title }}</strong>
                      <p class="mb-0 mt-1">{{ content[currentLang].warning.text }}</p>
                    </div>
                  </div>

                  <!-- Account Deletion Policy Section -->
                  <PolicySection
                    :title="content[currentLang].accountDeletion.title"
                    :icon="'fas fa-user-minus'"
                    :highlight="true"
                  >
                    <p class="text-dark">{{ content[currentLang].accountDeletion.intro }}</p>
                    <ul>
                      <li v-for="(item, index) in content[currentLang].accountDeletion.items" :key="index">
                        {{ item }}
                      </li>
                    </ul>
                  </PolicySection>

                  <!-- What Happens After Deletion Section -->
                  <PolicySection
                    :title="content[currentLang].afterDeletion.title"
                    :icon="'fas fa-trash-alt'"
                  >
                    <p class="text-dark">{{ content[currentLang].afterDeletion.intro }}</p>
                    <ul>
                      <li v-for="(item, index) in content[currentLang].afterDeletion.items" :key="index">
                        {{ item }}
                      </li>
                    </ul>
                  </PolicySection>

                  <!-- Data Retention & Privacy Section -->
                  <PolicySection
                    :title="content[currentLang].dataPrivacy.title"
                    :icon="'fas fa-shield-alt'"
                  >
                    <p class="text-dark">{{ content[currentLang].dataPrivacy.intro }}</p>
                    <ul>
                      <li v-for="(item, index) in content[currentLang].dataPrivacy.items" :key="index">
                        {{ item }}
                      </li>
                    </ul>
                  </PolicySection>

                </div>
                <!-- end policy content -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import PolicySection from './components/PolicySection.vue';

export default {
  name: "AccountDeletion",
  components: {
    PolicySection
  },
  data() {
    return {
      currentLang: 'ar',
      content: {
        ar: {
          warning: {
            title: 'تحذير هام!',
            text: 'حذف الحساب هو إجراء نهائي ولا يمكن التراجع عنه. يرجى التأكد من رغبتك في حذف حسابك قبل المتابعة، حيث ستفقد جميع بياناتك وتقدمك في الدورات بشكل دائم.'
          },
          accountDeletion: {
            title: 'سياسة حذف الحساب',
            intro: 'نحترم حقك في حذف حسابك في أي وقت. إليك كيفية طلب حذف الحساب:',
            items: [
              'يمكنك طلب حذف حسابك عبر التواصل مع فريق الدعم الفني.',
              'سيتم التحقق من هويتك قبل معالجة طلب الحذف.',
              'ستتم معالجة طلبات الحذف خلال 7-14 يوم عمل.',
              'ستتلقى تأكيدًا عبر البريد الإلكتروني أو الهاتف عند اكتمال الحذف.',
              'لا يمكن استرداد الحساب أو البيانات بعد الحذف النهائي.',
              'الاشتراكات المدفوعة غير قابلة للاسترداد بعد حذف الحساب.'
            ]
          },
          afterDeletion: {
            title: 'ماذا يحدث بعد حذف الحساب؟',
            intro: 'عند حذف حسابك، ستحدث التغييرات التالية:',
            items: [
              'سيتم حذف جميع معلوماتك الشخصية (الاسم، البريد الإلكتروني، رقم الهاتف).',
              'ستفقد الوصول إلى جميع الدورات المشتراة والمحتوى التعليمي.',
              'سيتم حذف سجل تقدمك في الدورات والاختبارات.',
              'ستُحذف جميع الشهادات والإنجازات المرتبطة بحسابك.',
              'لن تتمكن من استعادة أي بيانات بعد الحذف.',
              'قد نحتفظ ببعض البيانات المجهولة للأغراض الإحصائية فقط.'
            ]
          },
          dataPrivacy: {
            title: 'الاحتفاظ بالبيانات والخصوصية',
            intro: 'نلتزم بحماية خصوصيتك وفقًا لأفضل الممارسات:',
            items: [
              'نجمع فقط البيانات الضرورية لتقديم خدماتنا التعليمية.',
              'نستخدم تشفيرًا متقدمًا لحماية بياناتك الشخصية.',
              'لا نبيع أو نشارك بياناتك الشخصية مع أطراف ثالثة لأغراض تسويقية.',
              'نحتفظ ببياناتك طالما كان حسابك نشطًا أو حسب متطلبات القانون.',
              'يمكنك طلب نسخة من بياناتك الشخصية في أي وقت.',
              'نلتزم بالقوانين واللوائح المحلية والدولية لحماية البيانات.',
              'بيانات الدفع تُعالج بأمان عبر مزودي خدمة معتمدين ولا نخزنها بالكامل.'
            ]
          }
        },
        en: {
          warning: {
            title: 'Important Warning!',
            text: 'Account deletion is a permanent action and cannot be undone. Please make sure you want to delete your account before proceeding, as you will permanently lose all your data and course progress.'
          },
          accountDeletion: {
            title: 'Account Deletion Policy',
            intro: 'We respect your right to delete your account at any time. Here is how to request account deletion:',
            items: [
              'You can request account deletion by contacting our technical support team.',
              'Your identity will be verified before processing the deletion request.',
              'Deletion requests will be processed within 7-14 business days.',
              'You will receive confirmation via email or phone when deletion is complete.',
              'Account and data cannot be recovered after final deletion.',
              'Paid subscriptions are non-refundable after account deletion.'
            ]
          },
          afterDeletion: {
            title: 'What Happens After Account Deletion?',
            intro: 'When you delete your account, the following changes will occur:',
            items: [
              'All your personal information (name, email, phone number) will be deleted.',
              'You will lose access to all purchased courses and educational content.',
              'Your course progress and test records will be deleted.',
              'All certificates and achievements associated with your account will be removed.',
              'You will not be able to recover any data after deletion.',
              'We may retain some anonymized data for statistical purposes only.'
            ]
          },
          dataPrivacy: {
            title: 'Data Retention & Privacy',
            intro: 'We are committed to protecting your privacy according to best practices:',
            items: [
              'We only collect data necessary to provide our educational services.',
              'We use advanced encryption to protect your personal data.',
              'We do not sell or share your personal data with third parties for marketing purposes.',
              'We retain your data as long as your account is active or as required by law.',
              'You can request a copy of your personal data at any time.',
              'We comply with local and international data protection laws and regulations.',
              'Payment data is processed securely through certified service providers and is not fully stored by us.'
            ]
          }
        }
      }
    };
  },
  methods: {
    setLanguage(lang) {
      this.currentLang = lang;
    }
  },
  mounted() {
    document.title = this.currentLang === 'ar' 
      ? 'سياسة حذف الحساب | منصة أكاديميا' 
      : 'Account Deletion Policy | Academia Platform';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        this.currentLang === 'ar'
          ? 'تعرف على سياسة حذف الحساب وشروط الاستخدام والخصوصية في منصة أكاديميا التعليمية'
          : 'Learn about account deletion policy, terms of use, and privacy at Academia Educational Platform'
      );
    }
  },
  watch: {
    currentLang(newLang) {
      document.title = newLang === 'ar' 
        ? 'سياسة حذف الحساب | منصة أكاديميا' 
        : 'Account Deletion Policy | Academia Platform';
    }
  }
};
</script>

<style scoped>
.policy-content {
  line-height: 1.8;
  font-size: 15px;
  color: #333;
  max-width: 900px;
  margin: 0 auto;
}

.policy-content ul {
  padding-right: 20px;
  padding-left: 20px;
}

.policy-content ul li {
  margin-bottom: 8px;
}

.alert-warning {
  background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);
  border: none;
  border-radius: 16px;
  padding: 20px 24px;
  box-shadow: 0 4px 16px rgba(255, 193, 7, 0.15);
  position: relative;
  overflow: hidden;
}

.alert-warning::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #ffc107 0%, #ffca2c 100%);
  border-radius: 0 16px 16px 0;
}

[dir="rtl"] .alert-warning::before {
  right: auto;
  left: 0;
  border-radius: 16px 0 0 16px;
}

.alert-warning i {
  color: #d39e00;
  font-size: 28px;
}

.alert-warning strong {
  color: #856404;
  font-size: 16px;
}

.alert-warning p {
  color: #6d5a00;
}

.card {
  border: none !important;
  background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%) !important;
}

.btn-group .btn {
  padding: 8px 18px !important;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-group .btn:first-child {
  border-radius: 0 20px 20px 0 !important;
}

.btn-group .btn:last-child {
  border-radius: 20px 0 0 20px !important;
}

.btn-success {
  background: linear-gradient(135deg, #00a81c 0%, #00c922 100%) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(0, 168, 28, 0.25);
}

.btn-success:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 168, 28, 0.35);
}

.btn-light-success {
  background-color: #e8f5e9 !important;
  color: #00a81c !important;
  border: none !important;
}

.btn-light-success:hover {
  background-color: #c8e6c9 !important;
}

.custom-logo img {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

.bg-success.bg-opacity-10 {
  background: linear-gradient(135deg, rgba(0, 168, 28, 0.1) 0%, rgba(0, 201, 34, 0.15) 100%) !important;
}

h2.fw-bold {
  background: linear-gradient(135deg, #1a1a2e 0%, #2d2d44 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.rounded-pill.btn-success {
  background: linear-gradient(135deg, #00a81c 0%, #00c922 100%) !important;
  border: none !important;
  box-shadow: 0 4px 16px rgba(0, 168, 28, 0.3);
  transition: all 0.3s ease;
}

.rounded-pill.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 168, 28, 0.4);
}

.rounded-pill.btn-outline-success {
  border: 2px solid #00a81c !important;
  color: #00a81c !important;
  background: transparent !important;
  transition: all 0.3s ease;
}

.rounded-pill.btn-outline-success:hover {
  background: linear-gradient(135deg, #00a81c 0%, #00c922 100%) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 168, 28, 0.3);
}

@media (max-width: 991.98px) {
  .policy-content {
    padding: 0 10px;
  }
  
  .alert-warning {
    padding: 16px 18px;
  }
  
  .alert-warning i {
    font-size: 24px;
  }
}
</style>
